import React from "react";

import useNavigation from "../hooks/useNavigation";

import SchoolMobileListItem from "./components/SchoolMobileListItem";

const SchoolMobileMenuItem = ({ item }) => {
  const {
    closeMobileMenu,
    pushView,
  } = useNavigation();

  const hasMegaMenu = !!item.megaMenu?.sections?.length;

  const handleClick = () => {
    if (hasMegaMenu) {
      pushView({
        type: "megaMenu",
        title: item.label,
        data: item.megaMenu,
      });

      return;
    }

    closeMobileMenu();
  };

  return (
    <SchoolMobileListItem
      label={item.label}
      icon={item.icon}
      to={hasMegaMenu ? null : item.to}
      hasChildren={hasMegaMenu}
      onClick={handleClick}
    />
  );
};

export default SchoolMobileMenuItem;